module.exports = __webpack_public_path__ + "static/media/mywaste.525f36ab.png";